import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicTypeaheadCategoryWebBaseComponent } from '../base/dynamic-typeahead-category.web-base-component';

const SEARCH_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DynamicTypeaheadCategoryComponent),
  multi: true,
};

@Component({
  selector: 'ups-dynamic-typeahead-category',
  templateUrl: 'dynamic-typeahead-category.component.html',
  providers: [SEARCH_CONTROL_VALUE_ACCESSOR],
  // WI 35909 (S1): template state is marked at each async write in the shared typeahead bases
  // (WI 35584); this subclass adds no template-read async writes of its own.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicTypeaheadCategoryComponent extends DynamicTypeaheadCategoryWebBaseComponent {}
